const DEFAULTS = {
  useZoomDisable: true,
  useNightTime: true,
  TERMINAL_INACTIVITY_TIME: 3 * 60 * 1000,
  DEFAULT_ROTATE_ADS: 15 * 1000,
};

function readNumber(key, defaultValue) {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return defaultValue;
    const parsed = Number(raw);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : defaultValue;
  } catch {
    return defaultValue;
  }
}

function readBoolean(key, defaultValue) {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return defaultValue;
    return raw !== "false";
  } catch {
    return defaultValue;
  }
}

const terminalRuntimeConfig = {
  useZoomDisable: readBoolean("heidi_zoom_disable", DEFAULTS.useZoomDisable),
  useNightTime: readBoolean("heidi_night_time", DEFAULTS.useNightTime),
  TERMINAL_INACTIVITY_TIME: readNumber("heidi_inactivity_time", DEFAULTS.TERMINAL_INACTIVITY_TIME),
  DEFAULT_ROTATE_ADS: readNumber("heidi_rotate_ads", DEFAULTS.DEFAULT_ROTATE_ADS),
};

export function initTerminalRuntimeDefaults() {
  try {
    if (localStorage.getItem("heidi_zoom_disable") === null)
      localStorage.setItem("heidi_zoom_disable", String(DEFAULTS.useZoomDisable));
    if (localStorage.getItem("heidi_night_time") === null)
      localStorage.setItem("heidi_night_time", String(DEFAULTS.useNightTime));
    if (localStorage.getItem("heidi_inactivity_time") === null)
      localStorage.setItem("heidi_inactivity_time", String(DEFAULTS.TERMINAL_INACTIVITY_TIME));
    if (localStorage.getItem("heidi_rotate_ads") === null)
      localStorage.setItem("heidi_rotate_ads", String(DEFAULTS.DEFAULT_ROTATE_ADS));
  } catch {
    // localStorage unavailable — silently skip
  }
}

export default terminalRuntimeConfig;
